<!--
Author: zhangkun
Date: 2024-05-08
Desc: 基金转换
-->
<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/quickTrade' }">快速交易</el-breadcrumb-item>
                <el-breadcrumb-item
                    :to="{ path: '/quickTrade', query: { tab: isChange ? '3' : '4' } }"
                >
                    {{ isChange ? "转换" : "赎回转申购" }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-change-fund bizcomp ' + className">
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="260px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item label="转出基金：" class="form-text">
                    <div v-cloak class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item label="可用份额：" class="form-text red">
                    <div v-cloak class="text-con">
                        {{ $util.fmtNum(bankInfo.usableremainshare) }}
                        <span class="freeze">份</span>
                    </div>
                </el-form-item>
                <el-form-item label="转换渠道：" prop="transactionaccountid" class="payway-list">
                    <el-radio-group
                        v-model="fundInfo.transactionaccountid"
                        class="bank-radio"
                        vertical
                    >
                        <el-radio
                            v-for="(bank, index) in fund.fundArr"
                            :key="index"
                            :label="bank.transactionaccountid + bank.index"
                            border
                        >
                            <div class="bank-img-sel">
                                <img
                                    :src="
                                        $util.getImg(
                                            bank.paycenterid !== $util.getConfig().const.ZX_CENTER
                                                ? bank.bankcode
                                                : 'hf'
                                        )
                                    "
                                    alt=""
                                />
                                <div class="k-text-flow">
                                    <span
                                        v-cloak
                                        class="bank-name"
                                        :title="$cache.getDict('110080', bank.bankcode)"
                                    >
                                        {{ $cache.getDict("110080", bank.bankcode) }}({{
                                            bank.depositcard.substr(-7, 7)
                                        }})
                                    </span>
                                    总额(份)：
                                    <span class="bank-balance">
                                        {{ $util.fmtNum(bank.usableremainshare) }}
                                    </span>
                                </div>
                                <i class="el-icon-check" aria-hidden="true" />
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="转入基金："
                    prop="targetFund"
                    :class="{ 'redemp-amount': targetFundInfo.fundname }"
                >
                    <el-tooltip
                        :disabled="isShowTooltip"
                        :content="targetFundInfo.fundname + '(' + targetFundInfo.fundcode + ')'"
                        placement="top"
                    >
                        <el-select
                            v-model="fundInfo.targetFund"
                            filterable
                            :remote="!isChange"
                            :remote-method="searchFund"
                            placeholder="请选择转入基金"
                            v-on:visible-change="visibleChange"
                            v-on:change="selectcode"
                            v-on:mouseover.native="spanMouseenter($event)"
                        >
                            <el-option
                                v-for="item in targetFunds"
                                :key="item.fundcode"
                                :label="item.fundname + '(' + item.fundcode + ')'"
                                :title="item.fundname + '(' + item.fundcode + ')'"
                                :value="item.fundcode"
                            >
                                {{ item.fundname + "(" + item.fundcode + ")" }}
                            </el-option>
                        </el-select>
                    </el-tooltip>
                    <!--<p v-if="targetFundInfo.fundname" class="redemp-prompt">-->
                    <!--<i class="el-icon-warning" aria-hidden="true" />预计按照{{ targetFundInfo.fundname+'&nbsp;'+$util.fmtDate(targetFundInfo.navdate) }}的单位净值买入-->
                    <!--</p>-->
                </el-form-item>
                <el-form-item
                    v-if="fundInfo.sharetype"
                    label="收费方式："
                    prop="way"
                    class="form-text"
                >
                    <el-select v-model="fundInfo.sharetype" disabled>
                        <el-option value="A" label="前收费"></el-option>
                        <el-option value="B" label="后收费"></el-option>
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            前端收费是在申购基金时收取申购费,
                            <br />
                            而后端收费则是在申购时不收费，
                            <br />
                            在赎回时才收取手续费用。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item
                    label="转换份额："
                    prop="amount"
                    :class="{ 'form-text': !isPwdCheck && targetFundRisk.sign }"
                >
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                        :disabled="!targetFundInfo.fundname"
                    />
                    <!-- <span
                    v-if="!isAmountAll && targetFundInfo.fundname"
                    class="redemp-btn"
                    v-on:click="allSell"
                ><span
                    class="like-a"
                    v-on:click="allSell"
                >全部份额</span></span> -->
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="份额确认：">
                    {{ $util.capitalShare(fundInfo.amount, "份") }}
                </el-form-item>
                <!-- <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                <div class="text-con" v-html="feeH" />
            </el-form-item> -->
                <el-form-item
                    v-if="isPwdCheck"
                    label="交易密码："
                    prop="pwd"
                    :class="{ 'form-text': targetFundRisk.sign }"
                >
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="20"
                    />
                    <!--                    <span-->
                    <!--                        class="redemp-btn"-->
                    <!--                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"-->
                    <!--                    >-->
                    <!--                        <span class="like-a">忘记密码？</span>-->
                    <!--                    </span>-->
                </el-form-item>

                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="readFileInfoList.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="font-size: 14px; display: flex; align-items: flex-start"
                    >
                        <div style="display: flex; align-items: center">
                            <input
                                v-model="checkbox"
                                type="checkbox"
                                class="w18 h18"
                                v-on:click="agreeClick(index)"
                            />
                            <span class="ml4 c_999">同意</span>
                        </div>
                        <ul>
                            <li
                                v-for="(item, index) in readFileInfoList"
                                :key="index"
                                class="flex hcenter"
                            >
                                <a
                                    style="text-decoration: none; color: #1890ff; cursor: pointer"
                                    target="_blank"
                                    v-on:click="getClick(index)"
                                >
                                    《{{ item.filename }}》
                                </a>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <fund-risk-filter
                    v-show="!buySuccess"
                    :changefund="true"
                    :qryall="ismatch"
                    v-on:qry-change="qryChange"
                />
                <el-form-item>
                    <div style="width: 50%; margin-left: 70px">
                        <el-button class="medium back" v-on:click="$router.back()">
                            上一步
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :class="isOpen ? 'disable-btn' : 'active-btn'"
                            :disabled="isOpen"
                            :loading="isOpen"
                            v-on:click="submitInfo('fundInfo')"
                        >
                            确定
                            <span id="time"></span>
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <result
                v-if="buySuccess"
                :result="result"
                v-on:return-page="$router.push({ name: 'traderecord' })"
                v-on:return-login="$router.push({ name: 'home' })"
            />
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                v-on:close="finishReading"
            ></pdf-popup>
            <fund-protocol v-model="protocol" :fund="targetFundRisk" v-on:all-read="changeFund" />
        </div>
        <footerQuestions
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundProtocol from "@/components/form/fundProtocol";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import cache from "@/assets/js/cache";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "ChangeFund",
    components: {
        PdfPopup,
        result,
        fundRiskFilter,
        fundProtocol,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            targetfundcode: "",
            feeH: "", // 费率信息
            fundInfo: {
                availablevol: "",
                amount: "",
                transactionaccountid: "",
                targetFund: "",
                sharetype: "",
                pwd: ""
                // protocol: ""
            },
            checkbox: false, // 阅读确认1
            checkTime: true, // 阅读确认2
            readFileInfoList: [], // 披露文件信息
            readappno: "", // 申请单编号
            interval: "",
            ismatch: "1", // 适当性过滤字段
            protocol: false,
            isPwdCheck: false,
            isAmountAll: false,
            pla: "请选择转换目标基金",
            fund: {}, // 基金信息获取
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的基金转换申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            query: null,
            targetFunds: [], // 目标基金列表
            changeList: [], // 赎回转购时，可转换基金代码列表
            rules: {
                amount: [{ validator: this.amountLimit, trigger: "blur" }],
                sell: [
                    {
                        required: true,
                        message: "请选择取现方式",
                        trigger: "change"
                    }
                ],
                id: [
                    {
                        required: true,
                        message: "请选择取现渠道",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            limit: { min: "0.01", max: "0", text: "转换份额范围为：" },
            ZX_CENTER_ID: "",
            feeGate: {},
            targetFundInfo: {}, // 目标基金代码
            targetFundRisk: {}, // 目标基金适当性信息
            bankInfo: {},
            changecode: "",
            changeShareType: "",
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            commonQuestion: [],
            warningHtml: "",
            isChange: false, // 是否转换
            searchText: "", // 关键字搜索
            isApply: false, // 是否正在申请
            isShowTooltip: true, // 文本超长，显示tooltip
            isOpen: false // 正在发起请求
        };
    },
    watch: {
        "fundInfo.transactionaccountid"(val) {
            this.bankInfo = this.fund.fundArr.filter((item) => {
                return item.transactionaccountid + item.index === val;
            })[0];
            this.limitRefresh();
            // 切换渠道，清空检验信息
            this.$refs["fundInfo"].clearValidate();
        },
        "fundInfo.targetFund"(val) {
            this.targetFundInfo = this.targetFunds.filter((item) => {
                return item.fundcode === val;
            })[0];
            if (val !== "") {
                this.$set(this.fundInfo, "sharetype", this.targetFundInfo.sharetype.substr(0, 1));
            }
            this.limitRefresh();
        },
        "fundInfo.sharetype"(val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.amount"(val) {
            this.isAmount(val);
        },
        readFileInfoList: {
            handler: function (obj) {
                if (
                    obj.length > 0 &&
                    obj.every(function (item) {
                        return item.read; // 产品概要强制阅读，其他不用
                    })
                ) {
                    this.checkbox = true;
                }
            },
            deep: true
        },
        checkbox(val) {
            if (val && !this.isReadFileReading && !this.readFileInfoList[0].read) {
                this.currentFileInfoList = [this.readFileInfoList[0]];
                this.needTime = true;
                this.pdfVisible = true;
            }
            if (!val) {
                this.readFileInfoList.forEach((item) => (item.read = false));
            }
        }
    },
    mounted() {
        this.isChange = this.$route.name == "changefund";
        const info = this.$cache.getUser();
        this.ismatch = info.ismatch || "1";
        if (this.isChange) {
            this.commonQuestion = [
                {
                    title: "1.基金转换后什么时候开始确认份额？",
                    answer: "于当日下午3点前提交的基金转换，客户可以于T+1日确认交易有效性。于当日下午3点以后提交的基金转换指令，客户须于T+2日确认交易有效性。",
                    showFlag: false
                },
                {
                    title: "2.基金转换成交净值如何计算？",
                    answer: "基金转换采取未知价法，即以申请受理当日各转出、转入基金的基金份额净值为基础进行计算(货币市场基金的基金份额净值为固定价1元)。",
                    showFlag: false
                }
            ];
        }
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.initFundInfo();
    },
    methods: {
        // 选择目标基金
        selectcode(data) {
            this.changecode = data;
            this.changeShareType = this.fundInfo.sharetype;
            this.getFileInfo();
            if (!this.isChange && this.searchText.length) {
                this.searchText = "";
                this.getNormalFundList();
            }
        },
        // 文本太长显示不全，则显示Tooltip
        spanMouseenter(e) {
            let target = e.target;
            if (target.clientWidth < target.scrollWidth) {
                this.isShowTooltip = false;
            } else {
                this.isShowTooltip = true;
            }
        },
        // 获取披露文件信息
        getFileInfo() {
            if (this.changecode === "") {
                return;
            }
            this.readFileInfoList = [];
            const selectShareType = this.targetFunds.filter((item) => {
                return item.fundcode === this.changecode;
            })[0].sharetype;

            this.$util.queryReadFileInfo(
                {
                    fundcode: this.changecode,
                    sharetype: selectShareType,
                    filetype: ""
                },
                (res) => {
                    this.readFileInfoList = res;
                }
            );
        },
        // 获取链接点击事件
        getClick(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading() {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.isReadFileReading = true;
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            if (this.isApply) {
                return;
            }
            if (this.readFileInfoList.length) {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
            }
            this.isApply = true;
            setTimeout(() => {
                this.isApply = false;
            }, 3000);
            // 获取留痕申请编号
            const _this = this;
            this.$util.writeFileInfo(
                {
                    readFileInfoList: _this.readFileInfoList,
                    fundcode: _this.fund.fundcode,
                    tano: _this.fund.tano
                },
                (res) => {
                    _this.readappno = res;
                    _this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // 客户需求 不校验适当性
                            _this.changeFund();
                            // const proto = _this.isChange ? "change" : "sellToBuy";
                            // _this.$util.getSdxProtocol(
                            //     {
                            //         fundcode: _this.targetFundInfo.fundcode,
                            //         proto: proto
                            //     },
                            //     (res) => {
                            //         _this.targetFundRisk = res;
                            //         _this.protocol = true;
                            //     }
                            // );
                        } else {
                            _this.$errorScroll();
                        }
                    });
                }
            );
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.initFundInfo();
        },
        // 发起转换或赎回转申购
        async changeFund(val) {
            // this.protocol = false;
            // if (!val) return;
            const _this = this;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                this.isApply = false;
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            this.isOpen = true;
            try {
                let res = null;
                if (this.isChange) {
                    res = await fundApi.tradeConvert({
                        fundcode: _this.bankInfo.fundcode,
                        contractno: _this.readappno,
                        sharetype: _this.bankInfo.sharetype,
                        transactionaccountid: _this.bankInfo.transactionaccountid,
                        targetfundcode: _this.targetFundInfo.fundcode,
                        targetsharetype: _this.fundInfo.sharetype,
                        applicationvol: _this.fundInfo.amount,
                        tradepassword: this.isPwdCheck ? this.$util.enc(_this.fundInfo.pwd) : null
                    });
                } else {
                    res = await fundApi.combTransRedeemForBuy({
                        fundcode: _this.bankInfo.fundcode,
                        contractno: _this.readappno,
                        // sharetype: _this.bankInfo.sharetype,
                        transactionaccountid: _this.bankInfo.transactionaccountid,
                        targetfundcode: _this.targetFundInfo.fundcode,
                        // targetsharetype: _this.fundInfo.sharetype,
                        applicationvol: _this.fundInfo.amount,
                        tradepassword: this.isPwdCheck ? this.$util.enc(_this.fundInfo.pwd) : null,
                        redeemmode: "0",
                        largeredemptionflag: "0"
                    });
                }
                if (res.data) {
                    this.result.cla = "register-success";
                    const date = this.isChange ? res.data.cfmdate : res.data.transactioncfmdate;
                    this.result.btnMsg =
                        "预计确认：" + this.$util.fmtDate(date) + "， 如遇节假日则顺延";
                } else {
                    this.result.cla = "register-fail";
                    this.result.btnMsg = "原因：" + res.msg;
                }
                const prefix = this.isChange ? "您的转换申请已提交" : "您的赎回转申购申请已提交";
                this.result.msg = prefix + (this.result.cla === "register-fail" ? "失败" : "成功");
                this.buySuccess = true;
            } catch (e) {
                this.$log.error(e);
            } finally {
                this.isOpen = false;
            }
        },
        // 全部取现处理
        allSell() {
            this.fundInfo.amount = Number(this.bankInfo.usableremainshare) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                if (this.fundInfo.amount === this.bankInfo.usableremainshare) {
                    this.isAmountAll = true;
                } else {
                    this.isAmountAll = false;
                }
                // this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate() {
            const _this = this;
            let _d = null;
            if (
                this.fundInfo.amount > 0 &&
                this.fundInfo.sharetype === "A" &&
                this.bankInfo.channelid &&
                this.targetFundInfo.fundcode &&
                this.isChange
            ) {
                _d = {
                    fundcode: this.fund.fundcode,
                    amount: this.fundInfo.amount,
                    channelid: this.bankInfo.channelid,
                    bizcode: this.targetFundInfo.isconvert === "0" ? "8" : "7",
                    targetfundcode: this.targetFundInfo.fundcode,
                    businesscode: "036"
                };
            }
            this.$util.getFee(_d, (res) => {
                _this.feeGate = res;
                _this.feeH =
                    '<span class="red">' +
                    _this.$util.fmtNum(_this.feeGate.charge) +
                    "元</span>(<s>" +
                    _this.$util.fmtNum(_this.feeGate.originfee) +
                    '</s>元，为您节省<span class="red">' +
                    _this.$util.fmtNum(_this.feeGate.discount) +
                    "</span>元)";
            });
        },
        amountLimit(rule, value, callback) {
            rule.mes = this.isChange ? "转换份额" : "赎回转申购份额";
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 查询目标基金
        initFundInfo() {
            const info = this.$cache.getUser();
            if (info.ismatch != this.ismatch) {
                info.ismatch = this.ismatch;
                this.$store.dispatch("setInfo", info);
            }
            this.getChangeFundList();
            this.$set(
                this.fundInfo,
                "transactionaccountid",
                this.fund.fundArr[0].transactionaccountid + this.fund.fundArr[0].index
            );
            this.$set(this.fundInfo, "availablevol", this.fund.fundArr[0].usableremainshare);
        },
        // 赎回转申购，下拉列表消失，重新请求接口
        visibleChange(val) {
            if (!val) {
                this.searchFund("");
            }
        },
        // 关键词搜索基金
        searchFund(val) {
            if (!this.isChange) {
                // 赎回转申购
                this.searchText = val;
                this.getNormalFundList();
            }
        },
        // 查询可转换基金
        async getChangeFundList() {
            const res = await fundApi.queryTradeConvertInfo({
                qryallfund: this.isChange ? this.ismatch : "0",
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (res.data) {
                const list = res.data.datalist ? res.data.datalist : [];
                if (this.isChange) {
                    this.targetFunds = list;
                } else {
                    this.changeList = [];
                    list.forEach((item) => {
                        this.changeList.push(item.fundcode);
                    });
                    this.getNormalFundList();
                }
            }
        },
        // 查询全量基金 过滤支持转换、不能申购的基金
        async getNormalFundList() {
            const res = await fundApi.getFundLists({
                keyword: this.searchText,
                ismatch: this.ismatch,
                pagesize: 100,
                pagenum: 1
            });
            if (res.data) {
                let array = res.data.list ? res.data.list : [];
                this.targetFunds = array.filter((item) => {
                    return (
                        item.fundcode != this.fund.fundcode &&
                        this.changeList.indexOf(item.fundcode) == -1 &&
                        this.$util.checkBuy(item.status) == ""
                    );
                });
            }
        },
        // 获取目标基金适当性信息
        getTargetRisk(_code) {
            const _this = this;
            if (_code) {
                this.$util.fundRiskCheck(
                    _this,
                    { fundcode: _code, proto: "convert" },
                    function (data) {
                        _this.targetFundRisk = data;
                    }
                );
            }
        },
        // 获取限额
        async limitRefresh() {
            const type = this.isChange ? "转换" : "赎回转申购";
            if (this.bankInfo.usableremainshare == 0) {
                this.$set(this.limit, "max", 0);
                this.$set(this.limit, "min", 0);
                this.pla = `可用份额为0，无法${type}`;
                return;
            }
            if (this.bankInfo.channelid && this.targetFundInfo.fundcode) {
                // this.queryRate();
                this.getTargetRisk(this.targetFundInfo.fundcode);
                const code = this.isChange ? "036" : "099";
                this.$util.queryValidPwdTrdMethod(code, (res) => {
                    this.isPwdCheck = res;
                });
                let res = null;
                if (this.isChange) {
                    res = await fundApi.combQueryTargetFundLimit({
                        fundcode: this.fund.fundcode,
                        targetfundcode: this.targetFundInfo.fundcode
                    });
                } else {
                    res = await fundApi.combTransRedeemForBuyLimit({
                        fundcode: this.fund.fundcode,
                        targetfundcode: this.targetFundInfo.fundcode,
                        transactionaccountid: this.bankInfo.transactionaccountid
                    });
                }
                if (res.data && res.data.datalist) {
                    const limit = res.data.datalist.find((item) => {
                        return item.transactionaccountid == this.bankInfo.transactionaccountid;
                    });
                    if (!limit) {
                        return;
                    }
                    const _max =
                        Number(this.bankInfo.usableremainshare) > Number(limit.max)
                            ? limit.max
                            : this.bankInfo.usableremainshare;
                    this.$set(this.limit, "max", _max);
                    if (this.$util.fmtNum(limit.min) - 0 >= this.$util.fmtNum(_max) - 0) {
                        this.$set(this.limit, "min", _max);
                        this.pla = `本次${type}只能全额转换`;
                    } else {
                        this.$set(this.limit, "min", limit.min);
                        this.pla =
                            `本次${type}范围为` +
                            this.$util.fmtNum(limit.min) +
                            "-" +
                            this.$util.fmtNum(_max) +
                            "份";
                    }
                    if (this.fundInfo.amount) {
                        this.$refs.fundInfo.validateField("amount");
                    }
                }
            } else {
                this.pla = `请选择${type}目标基金`;
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-change-fund {
    .comp-fund-risk-filter {
        padding: 0 20px;
    }
    .back {
        color: #666666;
        background: #e4e4e4;
        border-color: transparent;
    }
    .active-btn {
        background: #e60012;
    }
    .disable-btn {
        background: #f7b2b8;
    }
    .bank-img-sel {
        box-sizing: border-box;
        width: 420px !important;
    }
}
</style>
